"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// every syleditor instance correspond a ReactRenderBridgeManager instance to
// manage all the react instance lifecycle belong to this editor
var RenderBridgeManager = /** @class */ (function () {
    function RenderBridgeManager() {
        var _this = this;
        // use `Set` implement cache traverse
        this.renderers = new Set();
        this.add = function (renderer) {
            if (!_this.renderers.has(renderer)) {
                _this.renderers.add(renderer);
            }
            else {
                // warning repeat
            }
        };
        this.remove = function (renderer) {
            if (_this.renderers.has(renderer)) {
                renderer.unmount();
                _this.renderers.delete(renderer);
            }
            else {
                // warning not exist
            }
        };
        this.unmountAll = function () {
            _this.renderers.forEach(function (renderer) { return renderer.unmount(); });
            _this.renderers = new Set();
        };
    }
    return RenderBridgeManager;
}());
exports.RenderBridgeManager = RenderBridgeManager;
// this cache all of manager and offer a way to approach manager
var RendererGlobalCache = /** @class */ (function () {
    function RendererGlobalCache() {
        var _this = this;
        this.store = new WeakMap();
        this.add = function (adapter) {
            if (!_this.store.has(adapter)) {
                var manager = new RenderBridgeManager();
                _this.store.set(adapter, manager);
            }
            else {
                // warning not exist
            }
        };
        this.remove = function (adapter) {
            var manager = _this.store.get(adapter);
            manager && manager.unmountAll();
            _this.store.delete(adapter);
        };
        this.get = function (adapter) {
            return _this.store.get(adapter) || null;
        };
    }
    return RendererGlobalCache;
}());
exports.RendererGlobalCache = RendererGlobalCache;
exports.rendererGlobalCache = new RendererGlobalCache();
//# sourceMappingURL=index.js.map